// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pCQ6iKxQ2qKiB_ {
  0% {
    width: 12px;
  }
  100% {
    width: 0px;
  }
}
.MDNnSjLtJhREhO {
  padding: var(--ds-space-0, 0);
}
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ {
  position: relative;
  width: 12px;
  height: 100%;
  background: transparent;
}
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 5px;
  width: 2px;
  height: 20px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: -10px;
  border-radius: 2px;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
@media (prefers-reduced-motion) {
  .MDNnSjLtJhREhO .KG3EohFXAEL5oQ {
    animation: unset;
  }
}
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ.Z4R5wSNa0sa0KF {
  animation: 0.1s 0.2s forwards pCQ6iKxQ2qKiB_;
}
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ.Z4R5wSNa0sa0KF:hover,
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ.Z4R5wSNa0sa0KF:focus {
  cursor: pointer;
}
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ.Z4R5wSNa0sa0KF::after,
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ.Z4R5wSNa0sa0KF::before {
  width: 0px;
}
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ:hover,
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ:focus,
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ.O5qwsh5aR3tHCy {
  cursor: ew-resize;
}
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ:hover::after,
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ:focus::after,
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ.O5qwsh5aR3tHCy::after {
  display: none;
}
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ:hover::before,
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ:focus::before,
.MDNnSjLtJhREhO .KG3EohFXAEL5oQ.O5qwsh5aR3tHCy::before {
  content: '';
  position: absolute;
  top: var(--ds-space-050, 4px);
  bottom: var(--ds-space-050, 4px);
  left: 5px;
  width: 2px;
  background-color: var(--ds-background-accent-blue-subtler-pressed, #579dff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dragAndDropDividerContainer": `MDNnSjLtJhREhO`,
	"dragAndDropDivider": `KG3EohFXAEL5oQ`,
	"hidden": `Z4R5wSNa0sa0KF`,
	"dividerAnim": `pCQ6iKxQ2qKiB_`,
	"dragging": `O5qwsh5aR3tHCy`
};
export default ___CSS_LOADER_EXPORT___;
